import { DataSourceMode, Label, LookupModelSelectionEvent, TableRow, TableRowCreationEvent, TableRowDisplayEvent, TableRowMode, Textbox, ValidationResult } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommFilterJunctionUserTable } from "./autogen/AutogenLayoutMobileCommFilterJunctionUserTable";

export class MobileCommFilterJunctionUserTable extends AutogenLayoutMobileCommFilterJunctionUserTable {
    tableMcFilterJunctionUserOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();

        if (tableRow.mode === TableRowMode.QUICK_ADD) {
            const labelEmail = tableRow.findComponentById("labelEmail") as Label;
            labelEmail.marginTop = 12;

            const labelPhone = tableRow.findComponentById("labelPhone") as Label;
            labelPhone.marginTop = 12;

            const labelCellPhone = tableRow.findComponentById("labelCellPhone") as Label;
            labelCellPhone.marginTop = 12;
        }
    }

    async textboxUserOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selectedRow = event.selection;
        if (selectedRow) {
            const tableRow = TableRow.getContainingTableRow(event.target);
            const textboxUser: Textbox = tableRow.findComponentById("textboxUser") as Textbox;

            textboxUser.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                if (mode === DataSourceMode.SEARCH) {
                    return null;
                }
                const result: ValidationResult = {
                    component: textboxUser,
                    isValid: true
                }

                this.tableMCFilterJunctionUser.rows.forEach(row =>  {
                    if (event.selection.get("id") === row.data.get("mc_object_id")) {
                        result.isValid = false;
                        result.validationMessage = "Row already exists for this user";
                        return;
                    }
                });
                return result;
            };

            const labelEmail: Label = tableRow.findComponentById("labelEmail") as Label;
            labelEmail.text = event.selection.get("email_address");

            const labelPhone: Label = tableRow.findComponentById("labelPhone") as Label;
            labelPhone.text = event.selection.get("phone");

            const labelCellPhone: Label = tableRow.findComponentById("labelCellPhone") as Label;
            labelCellPhone.text = event.selection.get("cell_phone");
        }
    }

    tableMCFilterJunctionUserOnRowCreate(event: TableRowCreationEvent) {
        const modelRow = event.getTableRow().data as ModelRow;
        const lmData = modelRow.getLookupModelData("mc_object_id");

        if (lmData) {
            modelRow.set("users.phone", lmData[0].get("phone"));
            modelRow.set("users.cell_phone", lmData[0].get("cell_phone"));
            modelRow.set("users.email_address", lmData[0].get("email_address"));
        }
    }
}
